<template>
  <div class="home">
    <div class="mb-lg-1 mb-xl-1">
      <RexModalLabel :primaryLabel="$t('alertTag')" />
    </div>
    <div class="d-flex flex-row mb-2" v-for="(row, index) in rows" :key="index">
      <div>
        <RexModalInput
          :disabled="disableTag"
          :modelValue="row.key"
          :placeholder="$t('alert.enter-key')"
          type="text"
          :id="'tag_key_' + index + ''"
          @update:modelValue="(val) => handleKeyInput(val, row)"
          @onBlur="(val) => $emit('validateTagKeyOnBlur', row)"
          style="width: 20.75em; height: 2.5em"
          inputBoxStyle="border-right: none !important; border-radius: 0.375rem 0 0 0.375rem !important"
        />
      </div>
      <div>
        <RexModalInput
          :disabled="disableTag"
          :modelValue="row.value"
          type="text"
          :id="'tag_value_' + index + ''"
          @update:modelValue="(val) => handleValueInput(val, row)"
          @onBlur="(val) => $emit('validateTagValueOnBlur', row)"
          :placeholder="$t('alert.enter-value')"
          style="width: 20.75em; height: 2.5em"
          inputBoxStyle="border-radius: 0 0.375rem 0.375rem 0 !important"
        />
      </div>
      <div>
        <div class="alertV2-form-add-tag-icon" v-if="checkCapabilitiesCall">
          <BaseIcon
            v-if="index === 0"
            class="action-icon"
            name="filledAdd"
            width="2.5em"
            height="2.5em"
            @click="addOneMoreTag"
            :disable="thisShow"
            :class="thisShow && 'stopClick'"
            :fill="'#f59600'"
          />
          <span v-else style="padding: 0.6em">
            <BaseIcon
              className="justify-content-center"
              class="action-icon"
              name="deleteFilled"
              width="1.25em"
              height="1.25em"
              @click="deleteOneLessTag(row)"
            />
          </span>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row mb-2">
      <RexInfoLabel
        :customStyle="'max-width:fit-content !important;word-wrap:break-word;'"
        :isError="true"
        :info="errorMessage"
        v-if="hasError"
      />
    </div>
  </div>
</template>
<script>
import RexButton from '@/rex-components/rex-button.vue';
import RexModalInput from '@/rex-components/rex-modal-input.vue';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import RexModalLabel from '@/rex-components/rex-modal-label.vue';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'AddAlertTags',
  components: {
    RexButton,
    RexModalInput,
    RexSearchSelect,
    RexModalLabel,
    RexInfoLabel,
  },
  props: {
    rows: {
      type: Array,
      default: () => [
        {
          key: '',
          value: '',
        },
      ],
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    disableTag: {
      type: Boolean,
      default: false,
    },
    isReadOnlyAccess: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('alertV2State/configure', ['getCurrentAlertCapability']),
    isAddNewTagEnabled() {
      return (
        this.rows?.length > 0 &&
        this.rows[this.rows.length - 1]?.key?.trim().length > 0 &&
        this.rows[this.rows.length - 1]?.value?.trim().length > 0
      );
    },
    thisShow() {
      return (
        this.hasError ||
        !this.isAddNewTagEnabled ||
        this.rows.length === 3 ||
        this.isReadOnlyAccess
      );
    },
    checkCapabilitiesCall() {
      if (
        this.getCurrentAlertCapability.key === 'APM' ||
        this.getCurrentAlertCapability.key === 'BROWSER' ||
        this.getCurrentAlertCapability.key === 'MOBILE' ||
        this.getCurrentAlertCapability.key === 'SM'
      ) {
        return false;
      }
      return true;
    },
  },
  created() {
    if (this.rows.length === 0) {
      this.rows.push({
        key: '',
        value: '',
      });
    }
  },
  async mounted() {},
  methods: {
    // decrement(){
    //   if (this.count !== 0) {
    //      return this.count--;
    //   }
    // },
    addOneMoreTag() {
      this.rows.push({
        key: '',
        value: '',
      });
      this.$emit('rows', this.rows, 'add');
    },
    clear() {
      this.rows = [];
      this.rows.push({
        key: '',
        value: '',
      });
      this.$emit('clear-rows', this.rows);
    },
    deleteOneLessTag(item) {
      this.rows.splice(this.rows.indexOf(item), 1);
      this.$emit('rows', this.rows, 'delete');
    },
    handleKeyInput(newKey, row) {
      this.rows[this.rows.indexOf(row)].key = newKey;
      this.$emit('rows', this.rows, 'keyInput', row);
    },
    handleValueInput(newValue, row) {
      this.rows[this.rows.indexOf(row)].value = newValue;
      this.$emit('rows', this.rows, 'valueInput', row);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.action-icon {
  cursor: pointer;
  fill: #f59600;
}
.stopClick {
  cursor: not-allowed;
  pointer-events: none;
  fill: rgb(101, 101, 101);
}
.alertV2-form-add-tag-icon {
  margin-left: 1.5rem;
}
</style>
